;(function ($) {

    const Quiz = {

        init() {
            $(document).ready(() => {
                this.observeResults();
            });
        },

        observeResults() {
            const parent = document.querySelector('.wpProQuiz_content');
            if (!parent) {
                return;
            }

            const observer = new MutationObserver(() => {
                const resultsEl = parent.querySelector('.wpProQuiz_results');
                if (resultsEl) {
                    const display = window.getComputedStyle(resultsEl).display;
                    if (display !== 'none') {
                        this.hideQuizPageElements();
                        this.showResultMessage();
                        observer.disconnect();
                    }
                }
            });

            observer.observe(parent, { attributes: true, subtree: true, childList: true });
        },

        hideQuizPageElements() {
            const heading = document.querySelector('.memberzone-content__heading');
            const tabs = document.querySelector('.ld-tabs');

            if (heading) {
                heading.style.display = 'none';
            }

            if (tabs) {
                tabs.style.display = 'none';
            }
        },

        showResultMessage() {
            const pointsEl = document.querySelector('.wpProQuiz_points--message');
            if (!pointsEl) {
                return;
            }

            const percentSpan = pointsEl.querySelectorAll('span')[2];
            if (!percentSpan) {
                return;
            }

            const achieved = parseInt(percentSpan.textContent.replace('%', ''), 10);
            const passEl = document.querySelector('.wpProQuiz_results-message--pass');
            const failEl = document.querySelector('.wpProQuiz_results-message--fail');
            const congratsEl = document.querySelector('.wpProQuiz_points--congratulations');
            const quizFailEl = document.querySelector('.wpProQuiz_points--quiz_fail');
            const passRate = parseInt(passEl.dataset.passRate, 10);

            if (achieved >= passRate) {
                if (failEl) {
                    failEl.style.display = 'none';
                }

                if (quizFailEl) {
                    quizFailEl.style.display = 'none';
                }
            } else {
                if (passEl) {
                    passEl.style.display = 'none';
                }

                if (congratsEl) {
                    congratsEl.style.display = 'none';
                }
            }
        },

    };

    if (document.querySelector('.wpProQuiz_content')) {
        Quiz.init();
    }

}(jQuery));